import * as React from "react";
import type { SVGProps } from "react";
const SvgNotFoundPageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={74}
    height={106}
    fill="none"
    viewBox="0 0 74 106" {...props}
  >
    <path
      stroke="#000"
      strokeWidth={0.6}
      d="m65.65 57.996-43.717-9.144L7.78 60.502 46.86 69.27z"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeWidth={0.6}
      d="m24.564 41.837-2.255 7.14 43.466 9.02 3.883-7.016zM15.92 47.099l6.013 1.879L8.154 60.627l-6.889-1.253zM67.027 91.942V66.013l-20.042 3.633.627 35.323z"
    />
    <path
      fill="#BED6FF"
      stroke="#00217B"
      strokeWidth={0.6}
      d="m43.2 71.949.095.008.083-.047 3.443-2 .677 34.896a3552 3552 0 0 1-19.626-5.334 3510 3510 0 0 0-19.793-5.38v-25.37z"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeWidth={0.6}
      d="M73.416 61.88c-1.804-1.504-6.138-3.174-8.017-3.758L46.86 69.27l7.265 6.89z"
    />
    <path fill="#C8E0FF" d="m22.434 63.884-.376-14.907L8.405 60.503z" />
    <path
      fill="#00217B"
      d="M44.383 4.536c.04 0 .08 0 .12.02 1.36.28 2.859 1 4.558 2.28 3.08 2.299 3.68 7.317 1.9 12.216-.18.5-.4 1-.62 1.52-.18.38-.36.76-.56 1.119-.48.88-1.04 1.72-1.66 2.54-.38.48-.76.94-1.159 1.359-4.659 5.018-10.817 6.418-14.936 3.879-.76-.48-1.4-.96-1.94-1.48-4.418-4.279-1.199-9.957 3.04-15.395 3.659-4.72 6.638-8.958 11.297-8.058z"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeMiterlimit={10}
      strokeWidth={0.6}
      d="M47.12 5.821c-4.145-3.215-11.35-.862-16.095 5.254-4.745 6.117-5.231 13.681-1.086 16.896s11.35.863 16.094-5.254 5.231-13.68 1.087-16.896Z"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeWidth={0.6}
      d="m44.48 78.038 2.63-8.643-38.83-8.768L.639 67.14z"
    />
    <path
      stroke="#B4BCD5"
      d="M50.416 66.5c-1.504-7.098-10-21.394-22.596-16.395-2.63 1.044-5.404 5.47 0 6.263C33.225 57.16 49.916 51 43.916 28.5"
    />
    <path
      fill="#FFCE00"
      d="M45.486 41.14a2.07 2.07 0 1 0 0-4.14 2.07 2.07 0 0 0 0 4.14"
    />
    <path
      fill="#00217B"
      d="m41.423 13.43-3.979 5.99-1.353-.855 3.705-6.163zm-6.313 8.185a1.07 1.07 0 0 1-.486-.683 1.06 1.06 0 0 1 .146-.826q.24-.378.678-.477.443-.097.825.145.375.235.478.678.107.444-.132.822-.162.257-.425.385a1.14 1.14 0 0 1-.549.123 1.04 1.04 0 0 1-.535-.167"
    />
  </svg>
);
export default SvgNotFoundPageIcon;
